'use strict';

var _mongoose = require('mongoose');

var _mongoose2 = _interopRequireDefault(_mongoose);

var _enums = require('../enums');

var _enums2 = _interopRequireDefault(_enums);

var _isVisible = require('./isVisible');

var _isVisible2 = _interopRequireDefault(_isVisible);

var _isVisibleItself = require('./isVisibleItself');

var _isVisibleItself2 = _interopRequireDefault(_isVisibleItself);

var _isPublished = require('./isPublished');

var _isPublished2 = _interopRequireDefault(_isPublished);

var _isLiteProfile = require('./helpers/isLiteProfile');

var _isLiteProfile2 = _interopRequireDefault(_isLiteProfile);

var _isVisibleAndNotLite = require('./helpers/isVisibleAndNotLite');

var _isVisibleAndNotLite2 = _interopRequireDefault(_isVisibleAndNotLite);

var _mongooseOptions = require('./mongooseOptions');

var _mongooseOptions2 = _interopRequireDefault(_mongooseOptions);

var _validUrl = require('valid-url');

var validUrl = _interopRequireWildcard(_validUrl);

var _Venue = require('../virtuals/Venue');

var _Venue2 = _interopRequireDefault(_Venue);

var _validatePhoneNumber = require('./helpers/validatePhoneNumber');

var _validatePhoneNumber2 = _interopRequireDefault(_validatePhoneNumber);

var _validateUrl = require('./helpers/validateUrl');

var _AddOn = require('./AddOn');

var _AddOn2 = _interopRequireDefault(_AddOn);

var _Space = require('./Space');

var _Space2 = _interopRequireDefault(_Space);

var _CancellationPolicy = require('./CancellationPolicy');

var _CancellationPolicy2 = _interopRequireDefault(_CancellationPolicy);

var _Delta = require('./Delta');

var _Delta2 = _interopRequireDefault(_Delta);

var _findByIdOrThrow = require('./plugins/findByIdOrThrow');

var _findByIdOrThrow2 = _interopRequireDefault(_findByIdOrThrow);

var _visibility = require('./plugins/visibility');

var _visibility2 = _interopRequireDefault(_visibility);

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Virtuals
var AmenitySchema = new _mongoose2.default.Schema({
  item: {
    type: String,
    enum: _enums2.default.venueAmenities,
    required: _isVisibleAndNotLite2.default
  },
  priceInCents: {
    type: Number,
    default: 0
  }
}, {
  _id: false,
  id: false,
  toObject: { virtuals: true },
  toJSON: { virtuals: true }
});

// Lodash


// Plugins


// Schemas


AmenitySchema.virtual('price').get(function () {
  if (!_isLiteProfile2.default.call(this)) {
    if (!this.priceInCents) {
      return '';
    }
    return (this.priceInCents / 100).toFixed(2);
  }
  return;
}).set(function (value) {
  this.priceInCents = value ? (parseFloat(value) * 100).toFixed(0) : null;
});

var model = new _mongoose2.default.Schema({
  internal: {
    // The lowest `priceInCents` for visible menus belonging to this venue
    searchPrice: { type: Number },
    menuPrices: [Number],
    deltas: [_Delta2.default],
    uuid: {
      type: String,
      select: false
    },
    statusChanges: [{
      person: {
        type: String,
        required: true
      },
      time: {
        type: Number,
        default: Date.now,
        required: true
      },
      oldValue: {
        type: String,
        required: true
      },
      newValue: {
        type: String,
        required: true
      }
    }]
  },
  bookingType: {
    type: String,
    required: false,
    default: "standard_Process",
    enums: _enums2.default.bookingType
  },
  authorizedUsers: [{
    title: String,
    preferences: {
      displayOnProposals: {
        type: Boolean,
        default: false
      },
      receiveEmails: {
        type: Boolean,
        default: false
      },
      receiveFinanceEmail: {
        type: Boolean,
        default: false
      }
    },
    user: {
      type: _mongoose2.default.Schema.Types.ObjectId,
      ref: 'BaseUser'
    }
  }],

  slug: String,

  yelpBusinessId: String,

  timesVenueBooked: {
    type: Number,
    default: 0
  },

  skipReview: {
    google: {
      type: Boolean,
      default: false
    },
    yelp: {
      type: Boolean,
      default: false
    }
  },

  hideReview: {
    google: {
      type: Boolean,
      default: false
    },
    yelp: {
      type: Boolean,
      default: false
    }
  },

  status: {
    type: String,
    required: true,
    enum: _enums2.default.venueStatuses,
    default: _enums2.default.venueStatuses[0] },

  data: {
    name: {
      type: String,
      required: [_isVisibleItself2.default, 'Venue name is required']
    },
    regularVenueName: {
      type: String
    },
    yelpVenueName: {
      type: String
    },
    googleVenueName: {
      type: String
    },
    kind: {
      type: String,
      required: [_isVisibleItself2.default, 'Venue type is required'],
      enum: _enums2.default.venueTypes
    },
    cuisineTypes: [{
      type: String,
      enum: _enums2.default.cuisineTypes
    }],
    payout: {
      method: { type: String, enum: _enums2.default.payout.methods }
    },
    price: {
      type: Number
    },
    amenities: [AmenitySchema],
    addOns: [_AddOn2.default],
    accolades: [{
      accolade: {
        type: String,
        enum: _enums2.default.liteProfileAccolades.DISTINCTIONS,
        required: [true, 'Accolade is required']
      },
      numberOfAccolades: {
        type: Number,
        required: [true, 'Number of accolade is required']
      },
      accoladeRating: {
        type: String,
        required: [true, 'Rating of accolade is required']
      },
      year: {
        type: String,
        required: [true, 'year is required']
      },
      imgUrl: {
        type: String,
        required: [true, 'imgUrl is required']
      },
      accoladeUrl: {
        type: String
      },
      date: {
        type: Date
      }
    }],

    ratingAndReviews: [{
      name: {
        type: String,
        enum: _enums2.default.liteProfileRatingWebsites,
        required: [true, 'Name is required']
      },
      rating: {
        type: Number
      },
      numberOfReviews: {
        type: Number
      },
      url: {
        type: String
      }
    }],

    address: {
      line1: {
        type: String,
        required: [_isVisibleItself2.default, 'Address 1 is required']
      },
      line2: String,
      city: { type: String, required: _isVisibleItself2.default },
      state: { type: String, required: _isVisibleItself2.default },
      neighborhood: String,
      zipcode: String,
      coordinates: {
        type: [Number],
        default: [0, 0]
      },
      country: String,
      googleMapsUrl: { type: String, get: encodeURIComponent },
      utcOffset: Number
    },
    virtualTourUrl: String,
    venueUrl: {
      type: String,
      validate: [_validateUrl.validateUrl, "Venue url must contain http:// or https://"],
      required: [_isLiteProfile2.default, 'Venue url is required for lite']
    },
    venueContactNumber: {
      type: String,
      validate: [_validatePhoneNumber2.default.validateNumber, 'Enter a valid phone number']
    },
    feeApplication: {
      fb: {
        admin: { type: Boolean, default: true },
        tax: { type: Boolean, default: true, set: function set(v) {
            return true;
          } },
        gratuity: { type: Boolean, default: true, set: function set(v) {
            return true;
          } }
      },
      nonFb: {
        admin: { type: Boolean, default: false },
        nonfbTax: { type: Boolean, default: true, set: function set(v) {
            return true;
          } },
        gratuity: { type: Boolean, default: false }
      },
      admin: {
        tax: { type: Boolean, default: false },
        nonfbTax: { type: Boolean, default: true },
        gratuity: { type: Boolean, default: false }
      },
      roomFee: {
        tax: { type: Boolean, default: false },
        nonfbTax: { type: Boolean, default: true },
        gratuity: { type: Boolean, default: false },
        admin: { type: Boolean, default: false }
      }
    },
    customFees: [{
      name: {
        type: String,
        required: true
      },
      value: {
        type: Number,
        required: true
      },
      feeType: {
        type: String,
        required: true,
        enum: ['percentage', 'flat']
      },
      appliesTo: {
        fb: { type: Boolean, default: false },
        nonFb: { type: Boolean, default: false },
        admin: { type: Boolean, default: false },
        roomFee: { type: Boolean, default: false }
      },
      appliedTo: {
        gratuity: { type: Boolean, default: false }
      },
      taxType: {
        type: String,
        default: 'none',
        enum: ['tax', 'nonfbTax', 'none']
      }
    }],
    fees: {
      admin: Number,
      tax: {
        type: Number,
        min: 0,
        required: [_isVisibleAndNotLite2.default, 'Food & Beverage Tax is required']
      },
      nonfbTax: {
        type: Number,
        min: 0,
        required: [_isVisibleAndNotLite2.default, 'Non Food & Beverage Tax is required']
      },
      gratuityPercentage: { type: Number, min: 0, default: 20 },
      additionalGuestPolicy: {
        type: {
          type: String,
          enum: _enums2.default.additionalGuestPolicy,
          default: 'No Fee'
        },
        fee: {
          type: Number,
          min: 0,
          required: [function (value) {
            var thePolicy = (0, _lodash.get)(this, 'data.fees.additionalGuestPolicy.type');
            if (_isVisibleItself2.default.call(this) && thePolicy && thePolicy !== 'No Fee') {
              return true;
            }
          }, 'Additional guest policy fee is required']
        }
      }
    },
    terms: {
      cancellationPolicies: [_CancellationPolicy2.default],
      daysToFinalizeEverything: {
        type: Number,
        required: [_isVisibleAndNotLite2.default, 'Days to finalize everything is required'],
        min: 0,
        validate: [function (days) {
          if (_isVisibleItself2.default.call(this) && (0, _lodash.get)(this, 'data.terms.daysToFinalizeMenu')) {
            return days <= this.data.terms.daysToFinalizeMenu;
          }
          return true;
        }, 'Days to finalize everything must be less than or equal to days to finalize menu']
      },
      daysToFinalizeMenu: {
        type: Number,
        required: [_isVisibleAndNotLite2.default, 'Days to finalize menu is required'],
        min: 0,
        validate: [function (days) {
          if (_isVisibleItself2.default.call(this) && (0, _lodash.get)(this, 'data.terms.daysToFinalizeEverything')) {
            return days >= this.data.terms.daysToFinalizeEverything;
          }
          return true;
        }, 'Days to finalize menu must be greater than or equal to days to finalize everything']
      },
      refundIssued: {
        type: String,
        enum: ['REFUND', 'NO_REFUND', 'DEFER_TO_VENUE']
      }
    },
    spaces: [_Space2.default],
    coverIndex: { type: Number, default: 0 },
    photos: [{
      caption: String,
      url: String
    }],
    videos: [{
      videoPlayerType: {
        type: String,
        default: _enums2.default.videoAccountsTypes[0],
        enum: _enums2.default.videoAccountsTypes
      },
      title: {
        type: String,
        default: _enums2.default.videoTitles[0],
        enum: _enums2.default.videoTitles
      },
      url: String,
      thumbnail: String,
      videoThumbnail: String
    }],
    about: String,
    winelists: [{
      caption: {
        type: String,
        required: !_isLiteProfile2.default,
        validate: function validate(str) {
          return str.length < 200;
        }
      },
      url: {
        type: String,
        required: !_isLiteProfile2.default,
        validate: validUrl.isUri
      }
    }]
  },
  admin: {
    profileOwner: { type: _mongoose2.default.Schema.Types.ObjectId, ref: 'BaseUser' },
    salesOwner: { type: _mongoose2.default.Schema.Types.ObjectId, ref: 'BaseUser' },
    profilePriority: { type: String, enum: _enums2.default.venueAdmin.profilePriorities },
    profileState: { type: String, enum: _enums2.default.venueAdmin.profileStates },
    dueDate: { type: Date },
    formAndGuidelines: {
      sent: { type: Date },
      received: { type: Date }
    },
    recoGuidance: { type: String, enum: _enums2.default.venueAdmin.recoGuidance.concat(null) },
    preferredPayoutMethod: {
      type: String,
      enums: _enums2.default.payout.sixplusPayoutMethods,
      default: 'SixPlus Credit Card'
    },
    lastBooking: { type: Date },
    createdBy: { type: String },
    contract: { type: String },
    advisory: {
      message: { type: String },
      staffFund: { type: String },
      takeaway: { type: String }
    },
    tagline: { type: String, required: _isPublished2.default },
    adminDescription: { type: String, required: _isPublished2.default || _isLiteProfile2.default },
    ambiance: {
      type: String,
      required: _isPublished2.default || _isLiteProfile2.default,
      validate: function validate(str) {
        if (_isPublished2.default.call(this) || _isLiteProfile2.default.call(this)) {
          return (0, _lodash.some)(_enums2.default.ambiance, function (ambiance) {
            return ambiance === str;
          });
        }
        return true;
      }
    },
    restaurantGroup: { type: String },
    critiques: [{
      author: { type: String, required: _isPublished2.default },
      review: { type: String, required: _isPublished2.default }
    }],
    // Higher priority = shows up higher in search results
    priority: { type: Number, default: 0 },
    commissionPercentage: { type: Number, min: 0, default: 0 },
    cardFeePercentage: { type: Number, min: 0, default: 0 },
    priceRange: { type: Number, min: 1, max: 4 },
    readableId: Number,
    rating: { type: Number },
    ratingCount: { type: Number },
    googleMapsUrl: { type: String },
    googlePlaceId: { type: String },
    network: { type: String }
  }
}, (0, _lodash.extend)((0, _lodash.cloneDeep)(_mongooseOptions2.default), { timestamps: true, usePushEach: true }));

model.set('emitIndexErrors', true);
model.index({ 'data.address.coordinates': '2d' });
model.index({ 'data.name': 'text', 'admin.restaurantGroup': 'text' });
model.index({ 'data.spaces.data.capacity.standing.min': 1, 'data.spaces.data.capacity.standing.max': 1 }, { name: 'SearchStandingCapacityIndex' });
model.index({ 'data.spaces.data.capacity.seated.min': 1, 'data.spaces.data.capacity.seated.max': 1 }, { name: 'SearchSeatedCapacityIndex' });
model.index({ 'data.address.city': 1, 'data.address.state': 1, 'data.address.country': 1 }, { name: 'CityStateCountryIndex' });

model.plugin(_findByIdOrThrow2.default, { name: 'Venue' });
model.plugin(_visibility2.default);

model.path('data.photos').validate(function (photos) {
  if (_isVisibleItself2.default.call(this) && !(this.data.photos || []).length) {
    return false;
  }
  return true;
}, _enums2.default.validationErrors.Venue.NO_PHOTO);

model.path('data.spaces').validate(function (spaces) {
  if (_isLiteProfile2.default.call(this) || _isPublished2.default.call(this)) {
    return spaces.filter(function (space) {
      return space.isVisible;
    }).length && (0, _lodash.some)(spaces, function (space) {
      return !space.validateSync();
    });
  }
  return true;
}, _enums2.default.validationErrors.Venue.NO_VALID_SPACE);

model.path('data.cuisineTypes').validate(function (types) {
  if (_isVisibleItself2.default.call(this)) {
    return types && types.length;
  }
  return true;
}, _enums2.default.validationErrors.Venue.NO_CUISINE_TYPE);

model.path('data.terms.cancellationPolicies').validate(function (policies) {
  if (_isVisibleItself2.default.call(this) && !_isLiteProfile2.default.call(this)) {
    var refundIssued = (0, _lodash.get)(this, 'data.terms.refundIssued');
    if (refundIssued === 'NO_REFUND' || refundIssued === 'DEFER_TO_VENUE') {
      return true;
    }
    var policiesOrdered = this.sortedCancellationPolicies;
    if (!policiesOrdered || !policiesOrdered.length) {
      return false;
    }

    // sort by order of availableBefore
    var theMin = (0, _lodash.get)(policiesOrdered[0], 'availableBefore');
    // start at index 1
    for (var i = 1; i < policiesOrdered.length; i++) {
      if (policiesOrdered[i].availableBefore > theMin) {
        return false;
      }
    }
    return true;
  }

  return true;
}, 'Invalid cancellation policy');

model.path('admin.critiques').validate(function (critiques) {
  if (_isPublished2.default.call(this)) {
    return critiques && critiques.length;
  }
  return true;
}, _enums2.default.validationErrors.Venue.NO_CRITIQUE);

model.virtual('admin.isVenuePartner').get(function () {
  return _Venue2.default.isVenuePartner(this);
});

model.virtual('coverImage').get(function () {
  if (this.data.photos.length && this.data.photos.length >= this.data.coverIndex) {
    return this.data.photos[this.data.coverIndex];
  }
  return this.data.photos[0] || { url: 'http://res.cloudinary.com/dbwijvnzn/image/upload/v1453314075/placeholder_xj1wzt.jpg' };
});

model.virtual('capacityRange').get(function () {
  if (!_isLiteProfile2.default.call(this)) {
    return _Venue2.default.capacityRange(this);
  }
});

model.virtual('minimumMenuPriceCents').get(function () {
  if (!_isLiteProfile2.default.call(this)) {
    return _Venue2.default.minimumMenuPriceCents(this);
  }
});

model.pre('validate', function (next) {
  if (!_isLiteProfile2.default.call(this)) {
    if (this.data.terms.cancellationPolicies) {
      var policies = this.data.terms.cancellationPolicies;
      for (var i = 0; i < policies.length; i++) {
        var isPenalty = policies[i].type === 'Penalty';
        if (isPenalty && !policies[i].availableBefore) {
          policies[i].availableBefore = 0;
          return next();
        }
      }
    }
  }
  next();
});

model.virtual('sortedCancellationPolicies').get(function () {
  if (!_isLiteProfile2.default.call(this)) {
    var strictnessOrder = _enums2.default.cancellationPolicy.strictnessOrder;
    var currentPolicies = (0, _lodash.get)(this, 'data.terms.cancellationPolicies', []);
    var sorted = (0, _lodash.compact)(strictnessOrder.map(function (policyType) {
      var thePolicy = (0, _lodash.find)(currentPolicies, function (policyObj) {
        return policyObj.type === policyType;
      });
      if (thePolicy) {
        return thePolicy;
      }
    }));
    var refundIssued = (0, _lodash.get)(this, 'data.terms.refundIssued');
    if (refundIssued === 'NO_REFUND') {
      var indexOfFirstAfterNoRefund = (0, _lodash.findIndex)(sorted, function (policyObj) {
        return strictnessOrder.indexOf(policyObj.type) > strictnessOrder.indexOf('No Refund');
      });
      sorted = indexOfFirstAfterNoRefund !== -1 ? sorted.slice(indexOfFirstAfterNoRefund) : [];
    }
    return sorted;
  }
  return;
});

model.virtual('schemaType').get(function () {
  return 'Venue';
});

model.virtual('newOnSixplus').get(function () {
  return _Venue2.default.isNewVenue(this);
});

model.virtual('publishedDate').get(function () {
  return _Venue2.default.getPublishedDate(this);
});

model.virtual('bookingPriority').get(function () {
  return _Venue2.default.isBookingPriority(this);
});

// Static methods

model.statics.generateSlug = generateSlug;
model.statics.getAssociatedVenues = getAssociatedVenues;
model.statics.removeAuthorizedUser = removeAuthorizedUser;

/**
 * Generates a slug for a venue based on its name, neighborhood, and city.
 * Defaults to just using the name and uses the neighborhood and city for the fallback
 *
 * @param {Doc} doc
 * @return {String, String}
 */
function generateSlug(doc) {
  var raw = [(0, _lodash.get)(doc, 'data.name', 'unnamed venue')];
  var slug = (0, _lodash.kebabCase)(raw.join(''));

  raw.push((0, _lodash.get)(doc, 'data.address.neighborhood', ''));
  raw.push((0, _lodash.get)(doc, 'data.address.city', ''));
  var fallback = (0, _lodash.kebabCase)(raw.join(''));

  return { slug: slug, fallback: fallback };
}

/**
 * Get venues for which a user is an authorized user
 *
 * @params {User} user
 * @params {Params} params, options for mongoose query
 * @return {Promise} => {Array}
 */
function getAssociatedVenues(user, params) {
  var options = {
    skipVisibility: true
  };
  (0, _lodash.merge)(options, params);

  return this.find({
    'authorizedUsers.user': user._id
  }).setOptions(options);
}

/**
 * Remove a user from a venue's authorized users Array. Automatically skips visibility and gets deleted
 *
 * @params {Venue}
 * @params {User}
 * @params {Params} params, mongoose query options
 * @return {Promise}
 */
function removeAuthorizedUser(venue, user, params) {
  var options = { skipVisibility: true, getDeleted: true };
  (0, _lodash.merge)(options, params);

  return this.findByIdAndUpdate(venue._id, { $pull: { 'authorizedUsers.user': user._id } }).setOptions(options);
}

/**
 * Filters venues based on search params
 *
 * @param {Options} options
 * @param {String} status
 * @param {String} city
 * @param {String} text
 * @return {Promise}
 */
model.statics.filterVenues = function filterVenues(options, status, city, text) {
  var queryParams = void 0;
  if (text) {
    queryParams = {};
    if (status) queryParams.status = status;
    if (city) queryParams['data.address.city'] = city;
    queryParams['$text'] = { $search: text };
    return this.find(queryParams).setOptions(options).exec();
  } else if (status && city) {
    return this.find({ 'data.address.city': city, 'status': status }).setOptions(options).exec();
  } else if (status) {
    return this.find({ 'status': status }).setOptions(options).exec();
  } else if (city) {
    return this.find({ 'data.address.city': city }).setOptions(options).exec();
  } else {
    return this.find().setOptions(options).exec();
  }
};

// Methods

/**
 * Get the address for a venue in a one-liner.
 * @example '123 W 20th St, New York, NY 10011, United States'
 * @return {String}
 */
model.methods.getAddress = function () {
  var name = this.get('data.name');
  var line1 = this.get('data.address.line1');
  var line2 = this.get('data.address.line2');
  var city = this.get('data.address.city');
  var country = this.get('data.address.country');
  return name + ', ' + line1 + (line2 ? ', ' + line2 + ',' : '') + ' ' + city + (country ? ', ' + country : '');
};

model.methods.getNearbyMajorCity = function () {
  return _Venue2.default.getNearbyMajorCity(this);
};

model.methods.publicUrl = function (domain) {
  return _Venue2.default.publicUrl(this, domain);
};

model.methods.editUrl = function (domain) {
  return domain + '/user/venues?venue=' + this.slug;
};

model.methods.privateUrl = function (domain) {
  return _Venue2.default.privateUrl(this, domain);
};

model.methods.getAuthorizedUsers = function (preferences) {
  return _Venue2.default.getAuthorizedUsers(this, preferences);
};

model.methods.getAuthorizedUsersToDisplay = function () {
  return _Venue2.default.getAuthorizedUsersToDisplay(this);
};

model.methods.getAuthorizedUsersToEmail = function () {
  return _Venue2.default.getAuthorizedUsersToEmail(this);
};

model.methods.getAuthorizedUsersForFinanceEmail = function () {
  return _Venue2.default.getAuthorizedUsersForFinanceEmail(this);
};

model.virtual('authorizedUsersToEmail').get(function () {
  return _Venue2.default.getAuthorizedUsersToEmail(this);
});

model.virtual('authorizedUsersToDisplay').get(function () {
  return _Venue2.default.getAuthorizedUsersToDisplay(this);
});

model.virtual('authorizedUsersForFinanceEmail').get(function () {
  return _Venue2.default.getAuthorizedUsersForFinanceEmail(this);
});

model.virtual('menus', {
  ref: 'menus',
  localField: '_id',
  foreignField: 'venue'
});

model.virtual('drinks', {
  ref: 'drinks',
  localField: '_id',
  foreignField: 'venue'
});

model.virtual('venueParentCity', {
  ref: 'locations',
  localField: 'data.address.city',
  foreignField: 'city'
});

module.exports = model;